export default {"src":"/_next/static/media/Read.978f433a.svg","height":7,"width":16,"blurWidth":0,"blurHeight":0};